import React, { useMemo } from 'react';
import { TaxUtils } from '@bingads-webui-clientcenter/entity-utils';
import { TaxCertificateFilePicker } from '../../controls';
import { ViewTaxFormPropTypes } from '../../shapes';
import { BaseViewTaxFormList, getPilotStatus } from '../../utils';
import { FileScenarioMapping, requiredFeatures } from '../../constants';

const { getRequiredForCustomerClaimTaxExemption } = TaxUtils;

export const CanadaViewTaxForm = ({
  i18n,
  filledData,
  taxCertification,
  taxFormMode,
  showLineByLineFormGroup,
  ownerAccountId,
  urlBuilder,
  showTaxCertLink,
  taxSchema,
  isXandrOnboarding,
  permissions,
}) => {
  const isCanadaTaxCertificateEnabled = getPilotStatus(requiredFeatures.XandrCanadaTaxCertificate, permissions) && isXandrOnboarding; // Currently only enable Canada tax exemption certificate for Xandr onboarding flow
  const additionalFormData = useMemo(() => ({ scenario: FileScenarioMapping.CA }), []);

  return (
    <div className="canada-view-tax-form">
      <BaseViewTaxFormList
        i18n={i18n}
        uiObject={filledData}
        taxSchema={taxSchema}
      />
      {isCanadaTaxCertificateEnabled && (
        <TaxCertificateFilePicker
          i18n={i18n}
          mtTaxCertification={taxCertification}
          taxFormMode={taxFormMode}
          showLineByLineFormGroup={showLineByLineFormGroup}
          ownerAccountId={ownerAccountId}
          urlBuilder={urlBuilder}
          showTaxCertLink={showTaxCertLink}
          taxCertLabel={getRequiredForCustomerClaimTaxExemption(i18n.getString(_TL_('Tax exemption certificate')), i18n)}
          additionalFormData={additionalFormData}
        />
      )}
    </div>
  );
};

CanadaViewTaxForm.propTypes = ViewTaxFormPropTypes;
